import React, { useRef, useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import { sizes } from 'src/styles/Media.styled';
import { makeStyles } from '@material-ui/core/styles';
import Header from './RowHeaderDesktop';
import { PriceOverrideAlert } from 'src/pages/reportUsage/submit/components/submissionComplete.styled';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import {
    FileMainContainer,
    FileUploadContainer,
    FileContainer,
    Title,
    UploadImageContainer,
    AddRecipientContainer,
    InputWithRecipientContainer,
    InputCont,
    Add,
    ErrorContainer,
    ReciepientContainer,
    DocumentSection,
    FileAndReciepientContainer,
    FileLinkContainer,
    FileNameContainer,
    DeleteIconContainer,
    IconBorder,
    StyledQuantityDiv,
    StyledTextDiv,
    WrappedDiv,
    StyledGrid,
} from './Discrepancy.styled';
import Input from 'src/common/components/form/input/Input';
import { useDispatch, useSelector } from 'react-redux';
import {
    usageDiscrepancyAttachmentUpload,
    deleteDiscrepancyAttachmentRequest,
    updateDisAttachmentAction,
    setDiscrepancyEmailIds,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import { checkPoFileExtension } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        // margin: 'auto',
        // maxWidth: 500,
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));

const Discrepancy = ({
    discrepencyUpdatedDetails,
    emailInputBoxes,
    setEmailInputBoxes,
}) => {
    const { t } = useTranslation();
    const [expandedCard, setExpandedCard] = useState({
        discrepancy: true,
    });
    const classes = useStyles();
    const { discrepancy } = expandedCard;
    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        lg: 2,
    };
    const winWidth = window.innerWidth;
    const { myCaseRefId, discrepancyAttachment, discrepancyDataUpdateLoader } =
        useSelector((state) => state.reportUsageRootReducer);

    const dispatch = useDispatch();

    const fileInput = useRef(null);
    const [warningMsg, setWarningMsg] = useState(false);
    const [warningText, setWarningText] = useState('');
    const [discrepencyFiles, setDiscrepencyFiles] = useState([]);
    const uploadedFilesNames =
        discrepencyUpdatedDetails?.discrepancyDto?.uploadedFileNames
            ?.split(',')
            ?.filter((x) => x !== '');

    const filesValidation = (files) => {
        let fileSizeError = false;
        let fileExtensionError = false;
        for (let i = 0; i < files.length; i++) {
            if (!checkPoFileExtension(files[i].name)) {
                fileExtensionError = true;
                setWarningText(t('equity.shipping.pleaseselectextension'));
                setWarningMsg(true);
                break;
            }
            if (files[i].size >= 10485760) {
                fileSizeError = true;
                setWarningText(t('equity.shipping.filesixenot20mb'));
                setWarningMsg(true);
                break;
            }
        }

        return !fileExtensionError && !fileSizeError;
    };
    const onFileChange = (event) => {
        const fileCount = discrepancyAttachment?.length
            ? discrepancyAttachment.filter((item) => item != '')?.length
            : 0;
        if (event.target.files.length + fileCount <= 5) {
            if (filesValidation(event.target.files)) {
                dispatch(
                    usageDiscrepancyAttachmentUpload({
                        files: event.target.files,
                        myCaseRef: myCaseRefId,
                    })
                );
                // dispatch(
                //     fetchUsageDetailsRequest({
                //         resourceType: myCaseResourceType,
                //         myCaseRef: myCaseRefId,
                //         isDiscrepencyCheck: true,
                //     })
                // );
                setWarningText('');
                setWarningMsg(false);
            }
        } else {
            setWarningText(t('common.max5canbeadded'));
            setWarningMsg(true);
        }
    };

    const onAddEmailRecipientHandler = () => {
        let previous = [...emailInputBoxes, { value: '', errorMessage: '' }];
        setEmailInputBoxes(previous);
        dispatch(setDiscrepancyEmailIds(previous));
    };
    const onChangeEmail = (index, value) => {
        const emailInputBox = [...emailInputBoxes];
        emailInputBox[index].value = value;
        setEmailInputBoxes(emailInputBox);
        dispatch(setDiscrepancyEmailIds(emailInputBox));
    };
    const onDeleteClick = (fileName) => {
        const obj = {
            fileName,
        };
        dispatch(deleteDiscrepancyAttachmentRequest(obj));
    };

    useEffectWithErrorLogging(() => {
        if (discrepancyDataUpdateLoader) {
            return;
        }
        if (uploadedFilesNames?.length > discrepancyAttachment?.length) {
            let disAttachment = [];
            disAttachment.push(...uploadedFilesNames);
            dispatch(updateDisAttachmentAction(disAttachment));
            setDiscrepencyFiles(disAttachment);
        } else {
            setDiscrepencyFiles(discrepancyAttachment);
        }
    }, [discrepancyAttachment, discrepencyUpdatedDetails]);

    return (
        <>
            <CollapsableCard id="reportUsage-discrepancy-discrepancy-discrepancyReport"
                title={t(
                    'orders.reportsAndInvoice.sendUsageReport.DiscrepancyReport'
                )}
                onClick={() => toggleCard('discrepancy', !discrepancy)}
                isExpanded={discrepancy}
                margin={'0px 0px 10px 0px'}
            >
                {discrepancy && (
                    <>
                        {winWidth > sizes.mobileDevice && <Header />}
                        {discrepencyUpdatedDetails?.discrepancyDto
                            ?.discrepancyEntries &&
                            discrepencyUpdatedDetails?.discrepancyDto?.discrepancyEntries?.map(
                                (item, index) => (
                                    <Box
                                        key={index}
                                        className={classes.paper}
                                        my={1}
                                        bgcolor={'#ffffff'}
                                        boxShadow={2}
                                        borderRadius={6}
                                    >
                                        <Grid
                                            container
                                            alignItems={'flex-start'}
                                        >
                                            <Grid item xs={5} lg={5} md={5}>
                                                <TextWithClicks
                                                    classes={classes}
                                                    media={mediaSizes}
                                                    leftTitle={item?.productCFN}
                                                    typeNonTissue={
                                                        item?.salesOrg ===
                                                        'S002'
                                                            ? 'NT'
                                                            : item?.salesOrg ===
                                                                  'S030' && 'T'
                                                    }
                                                    typeEA={item?.uom}
                                                    styleObj={{
                                                        tagsStyle: {
                                                            padding:
                                                                '0 0 0 30px',
                                                        },
                                                    }}
                                                    mdPadding={
                                                        '0 0 0 25px !important'
                                                    }
                                                />
                                                <CustomLabel
                                                    fSize={'12px !important'}
                                                    paddingRight={
                                                        '2rem!important'
                                                    }
                                                    color={'#140F4B'}
                                                    label={item?.description}
                                                    opacity={0.7}
                                                />
                                            </Grid>
                                            <StyledGrid
                                                item
                                                xs={1}
                                                lg={1}
                                                md={1}
                                                spacing={1}
                                                alignItems={'flex-start'}
                                                justifyContent={'space-between'}
                                            >
                                                <CustomLabel
                                                    fSize={'12px !important'}
                                                    color={'#202124'}
                                                    fWeight={'bold'}
                                                    marginLeft={'-3px'}
                                                    label={`${t(
                                                        'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                    )} ${item?.usedQuantity}`}
                                                />

                                                <CustomLabel
                                                    fSize={'12px !important'}
                                                    color={'#202124'}
                                                    fWeight={'bold'}
                                                    marginLeft={'-6px'}
                                                    label={`${t(
                                                        'reportUsage.record.priceOverride.AccountOwnedList.index.other'
                                                    )} ${item?.otherQuantity}`}
                                                />
                                            </StyledGrid>
                                            <StyledGrid
                                                item
                                                xs={3}
                                                lg={3}
                                                md={3}
                                                spacing={1}
                                                alignItems={'flex-start'}
                                                justifyContent={
                                                    winWidth >=
                                                    sizes.mediumDevice
                                                        ? 'space-between'
                                                        : 'flex-end'
                                                }
                                            >
                                                <CustomLabel
                                                    fSize={'12px !important'}
                                                    color={'#202124'}
                                                    fWeight={'bold'}
                                                    ldPaddingRight={
                                                        '2rem!important'
                                                    }
                                                    mdPaddingRight={
                                                        '5px !important'
                                                    }
                                                    marginLeft={'-3px'}
                                                    textAlign={'right'}
                                                    label={item?.repAdjustedQty}
                                                />
                                            </StyledGrid>
                                            <StyledGrid
                                                item
                                                xs={3}
                                                lg={3}
                                                md={3}
                                                spacing={1}
                                                alignItems={'flex-start'}
                                                justifyContent={'space-between'}
                                            >
                                                <CustomLabel
                                                    fSize={'12px !important'}
                                                    fWeight={'bold'}
                                                    ldPaddingRight={
                                                        '3rem!important'
                                                    }
                                                    mdPaddingRight={
                                                        '1.4rem!important'
                                                    }
                                                    marginLeft={'-3px'}
                                                    textAlign={'right'}
                                                    color={'#ED002A'}
                                                    label={item?.hospitalQty}
                                                />
                                            </StyledGrid>
                                            <Grid
                                                item
                                                xs={3}
                                                lg={3}
                                                md={3}
                                                spacing={1}
                                                alignItems={'flex-start'}
                                                justifyContent={'space-between'}
                                            >
                                                <StyledQuantityDiv>
                                                    <CustomLabel
                                                        fSize={
                                                            '12px !important'
                                                        }
                                                        color={'#202124'}
                                                        fWeight={'bold'}
                                                        paddingRight={
                                                            '2rem!important'
                                                        }
                                                        marginLeft={'0'}
                                                        label={`${t(
                                                            'reportUsage.record.itemsList.QuantityInputBoxes.used'
                                                        )}: ${
                                                            item?.usedQuantity
                                                        }`}
                                                    />

                                                    <CustomLabel
                                                        fSize={
                                                            '12px !important'
                                                        }
                                                        color={'#202124'}
                                                        fWeight={'bold'}
                                                        paddingRight={
                                                            '0rem!important'
                                                        }
                                                        marginLeft={'0'}
                                                        label={`${t(
                                                            'reportUsage.record.priceOverride.AccountOwnedList.index.other'
                                                        )} ${
                                                            item?.otherQuantity
                                                        }`}
                                                    />
                                                </StyledQuantityDiv>
                                            </Grid>
                                            <WrappedDiv>
                                                <StyledTextDiv
                                                    fSize={'13px'}
                                                    color={'#202124'}
                                                    fWeight={'bold'}
                                                    fontFamily={
                                                        'AvenirNextWorld demi'
                                                    }
                                                    padding={'0 60px 0 0'}
                                                >
                                                    {t(
                                                        'reportUsage.review.discrepancy.RowHeaderDesktop.qtyReportedByMedRep'
                                                    )}
                                                    <span>
                                                        {' '}
                                                        {item?.repAdjustedQty}
                                                    </span>
                                                </StyledTextDiv>
                                                <StyledTextDiv
                                                    fSize={'13px'}
                                                    color={'#202124'}
                                                    fWeight={'bold'}
                                                    fontFamily={
                                                        'AvenirNextWorld demi'
                                                    }
                                                >
                                                    {t(
                                                        'reportUsage.review.discrepancy.RowHeaderDesktop.qtyReportedByHos'
                                                    )}
                                                    <span
                                                        style={{
                                                            color: '#ED002A',
                                                        }}
                                                    >
                                                        {' '}
                                                        {item?.hospitalQty}
                                                    </span>
                                                </StyledTextDiv>
                                            </WrappedDiv>
                                            {/* <PoInfoView
                                                reviewPage={true}
                                                item={item}
                                            /> */}
                                        </Grid>
                                    </Box>
                                )
                            )}

                        <PriceOverrideAlert
                            margin={'20px 0 20px 7px'}
                            alertMessageMobileMargin={'0 0 17px 4px'}
                        >
                            <AlertMsg
                                header={t(
                                    'reportUsage.discrpancyAlertMessage.UsageDescrepancyMessageHeader'
                                )}
                                message={t(
                                    'reportUsage.discrpancyAlertMessage.UsageDiscrepancyMessage'
                                )}
                                lineHeight={'20px'}
                            />
                        </PriceOverrideAlert>
                        <FileMainContainer>
                            <FileUploadContainer>
                                <DocumentSection>
                                    <Title
                                        paddingBtm={'10px'}
                                        paddingTop={'5px'}
                                    >
                                        <span>
                                            {t(
                                                'reportUsage.review.discrepancy.DiscrepancyMobile.attachedDocument'
                                            )}
                                        </span>
                                        <span className="asterisk">*</span>
                                    </Title>
                                    <input
                                        onChange={onFileChange}
                                        id="file-upload"
                                        type="file"
                                        // accept=".jpg,.jpeg,.gif,.png,.tif,.tiff,.pdf,.bmp,.msg,.doc,.docx,.xls,.txt,.html"
                                        hidden
                                        ref={fileInput}
                                        multiple
                                    />
                                    <UploadImageContainer
                                        onClick={() =>
                                            fileInput.current &&
                                            fileInput.current.click()
                                        }
                                    >
                                        <label>
                                            {t(
                                                'reportUsage.review.discrepancy.DiscrepancyMobile.uploadLabel'
                                            )}
                                        </label>
                                    </UploadImageContainer>
                                </DocumentSection>
                                {warningMsg && (
                                    <ErrorContainer>
                                        {warningText}
                                    </ErrorContainer>
                                )}
                                <FileContainer>
                                    {discrepencyFiles?.map((file, index) => (
                                        <>
                                            {file != '' && (
                                                <FileLinkContainer key={index}>
                                                    <FileNameContainer>
                                                        {file}
                                                    </FileNameContainer>
                                                    <DeleteIconContainer
                                                        onClick={() =>
                                                            onDeleteClick(file)
                                                        }
                                                        style={{}}
                                                    >
                                                        <IconBorder style={{}}>
                                                            <img
                                                                src={
                                                                    DeleteLight
                                                                }
                                                                style={{
                                                                    width: 20,
                                                                    height: 20,
                                                                    margin: '6px',
                                                                }}
                                                            />
                                                        </IconBorder>
                                                    </DeleteIconContainer>
                                                </FileLinkContainer>
                                            )}
                                        </>
                                    ))}
                                </FileContainer>
                            </FileUploadContainer>
                            <FileAndReciepientContainer>
                                <Title paddingBtm={'10px'} paddingTop={'5px'}>
                                    <span>
                                        {t(
                                            'reportUsage.review.discrepancy.DiscrepancyMobile.sendToEmailAddress'
                                        )}
                                    </span>
                                    <span className="asterisk">*</span>
                                </Title>
                                <ReciepientContainer>
                                    {emailInputBoxes?.map((item, index) => (
                                        <>
                                            <AddRecipientContainer
                                                flexDirection={'row'}
                                                alignItems="flex-start"
                                            >
                                                <InputWithRecipientContainer
                                                    smFlexDirection={'column'}
                                                    alignItems={'flex-start'}
                                                >
                                                    <InputCont
                                                        key={index}
                                                        smWidth={'100%'}
                                                    >
                                                        <Input
                                                            id={`email-input-${index}`}
                                                            placeholder={t(
                                                                'reportUsage.review.discrepancy.DiscrepancyMobile.emailAddress'
                                                            )}
                                                            onChange={(event) =>
                                                                onChangeEmail(
                                                                    index,
                                                                    event.target
                                                                        .value
                                                                )
                                                            }
                                                            value={
                                                                item?.value ||
                                                                ''
                                                            }
                                                        />
                                                    </InputCont>
                                                    {item?.errorMessage && (
                                                        <ErrorContainer>
                                                            {item.errorMessage}
                                                        </ErrorContainer>
                                                    )}
                                                    {emailInputBoxes?.length -
                                                        1 ===
                                                        index && (
                                                        <Add
                                                        id={`add-recipient-${index}`}
                                                            onClick={
                                                                onAddEmailRecipientHandler
                                                            }
                                                        >
                                                            {t(
                                                                'orders.reportsAndInvoice.requestInvoice.addrecipit'
                                                            )}
                                                        </Add>
                                                    )}
                                                </InputWithRecipientContainer>
                                            </AddRecipientContainer>
                                        </>
                                    ))}
                                </ReciepientContainer>
                            </FileAndReciepientContainer>
                        </FileMainContainer>
                    </>
                )}
            </CollapsableCard>
        </>
    );
};

export default Discrepancy;
